// import './polyfills';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Keys kept across a load so the job posting context (client suffix + job code)
// survives a refresh. The storage key is needed to decrypt them.
const PRESERVED_SESSION_KEYS = ['jobUrlParam', '__amw_secure_storage_key'];

try {
  localStorage.clear();

  const preserved = PRESERVED_SESSION_KEYS
    .map(key => [key, sessionStorage.getItem(key)])
    .filter(([, value]) => value !== null);

  sessionStorage.clear();
  preserved.forEach(([key, value]) => sessionStorage.setItem(key, value));
} catch (error) {
  console.error('Failed to clear browser storage on startup', error);
}

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(<App/>);

serviceWorker.unregister();